(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["digio-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('digio-product-extras')) {
    customElements.define('digio-product-extras', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = document.getElementById(this.dataset.formId) || this.closest('form');
        if (!this.form) return;
        this.productCache = new Map();
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'el', { style: 'currency', currency: this.dataset.currency });
        this.querySelectorAll('[data-extra-checkbox]').forEach(input => { input.disabled = input.dataset.unavailable === 'true'; });
        this.onChange = event => this.handleChange(event);
        this.onToggle = () => {
          const list = this.querySelector('.digio-extras__list');
          const more = this.querySelector('[data-extra-more]');
          const expanded = list.dataset.expanded !== 'true';
          list.dataset.expanded = String(expanded);
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? this.dataset.less : this.dataset.more;
        };
        this.querySelector('[data-extra-more]').addEventListener('click', this.onToggle);
        this.onClick = event => {
          const button = event.target.closest?.('.gp-button-atc, .product-form__submit');
          if (!button || button.form !== this.form || !this.hasSelection()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addSelection(button);
        };
        this.onSubmit = event => {
          if (event.target !== this.form || !this.hasSelection()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addSelection(event.submitter || this.form.querySelector('.gp-button-atc, .product-form__submit'));
        };
        this.addEventListener('change', this.onChange);
        window.addEventListener('click', this.onClick, true);
        window.addEventListener('submit', this.onSubmit, true);
        this.updateSummary();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.querySelector('[data-extra-more]')?.removeEventListener('click', this.onToggle);
        window.removeEventListener('click', this.onClick, true);
        window.removeEventListener('submit', this.onSubmit, true);
        this.initialized = false;
      }
      hasSelection() { return !!this.querySelector('[data-extra-checkbox]:checked'); }
      normalize(value) { return value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9Α-Ω]/g, ''); }
      showError(message) {
        const error = this.querySelector('[data-extra-error]');
        error.textContent = message || '';
        error.hidden = !message;
      }
      async handleChange(event) {
        const row = event.target.closest('[data-extra-handle]');
        if (!row) return;
        const checkbox = row.querySelector('[data-extra-checkbox]');
        const select = row.querySelector('[data-extra-select]');
        this.showError('');
        if (event.target === checkbox && select) {
          row.querySelector('[data-extra-choice]').hidden = !checkbox.checked;
          select.disabled = !checkbox.checked;
          if (checkbox.checked && !select.dataset.loaded) await this.loadScents(row, select, checkbox);
        }
        if (event.target === select) this.selectScent(row, select, checkbox);
        this.updateSummary();
      }
      async loadScents(row, select, checkbox) {
        select.disabled = true;
        select.options[0].textContent = this.dataset.loading;
        try {
          const handle = row.dataset.extraHandle;
          if (!this.productCache.has(handle)) {
            const root = window.Shopify?.routes?.root || '/';
            this.productCache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(response => {
              if (!response.ok) throw new Error();
              return response.json();
            }));
          }
          const product = await this.productCache.get(handle);
          select.options[0].textContent = this.dataset.choose;
          for (const variant of product.variants.filter(variant => variant.available)) {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = variant.title + ' (+' + this.money.format(variant.price / 100) + ')';
            option.dataset.price = String(variant.price);
            option.dataset.scent = variant.title;
            select.append(option);
          }
          select.dataset.loaded = 'true';
          const sameScent = [...select.options].find(option => option.dataset.scent && this.normalize(option.dataset.scent) === this.normalize(this.dataset.scent));
          if (sameScent) {
            select.value = sameScent.value;
            this.selectScent(row, select, checkbox);
          }
        } catch {
          this.productCache.delete(row.dataset.extraHandle);
          select.options[0].textContent = this.dataset.choose;
          checkbox.checked = false;
          row.querySelector('[data-extra-choice]').hidden = true;
          this.showError(this.dataset.error);
        } finally {
          select.disabled = !checkbox.checked;
          this.updateSummary();
        }
      }
      selectScent(row, select, checkbox) {
        const option = select.selectedOptions[0];
        checkbox.value = option?.value || '';
        row.dataset.price = option?.dataset.price || '0';
        row.querySelector('[data-extra-scent]').textContent = option?.dataset.scent || this.dataset.choose;
        row.querySelector('[data-extra-price]').textContent = option?.value ? '+' + this.money.format(Number(option.dataset.price) / 100) : '';
      }
      updateSummary() {
        const checked = [...this.querySelectorAll('[data-extra-checkbox]:checked')];
        const total = checked.reduce((sum, input) => sum + Number(input.closest('[data-extra-handle]').dataset.price || 0), 0);
        this.querySelector('[data-extra-summary]').hidden = !checked.length;
        this.querySelector('[data-extra-total]').textContent = '+' + this.money.format(total / 100);
        this.form.classList.toggle('digio-has-extras', !!checked.length);
      }
      async addSelection(button) {
        if (this.busy || button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
        const checked = [...this.querySelectorAll('[data-extra-checkbox]:checked')];
        const invalid = checked.find(input => !input.value);
        if (invalid) {
          this.showError(this.dataset.required);
          invalid.closest('[data-extra-handle]').querySelector('select')?.focus();
          return;
        }
        const formData = new FormData(this.form);
        const perfumeId = formData.get('id');
        const quantityInput = this.form.querySelector('[name="quantity"]:not([type="hidden"])');
        const quantity = Number(quantityInput?.value || formData.get('quantity') || 1);
        if (!perfumeId || !Number.isSafeInteger(quantity) || quantity < 1) return;
        const properties = {};
        for (const [key, value] of formData) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        const perfume = { id: perfumeId, quantity, properties };
        if (formData.get('selling_plan')) perfume.selling_plan = formData.get('selling_plan');
        const items = [perfume, ...checked.map(input => ({ id: input.value, quantity: 1 }))];
        const root = window.Shopify?.routes?.root || '/';
        this.busy = true;
        this.showError('');
        this.setAttribute('aria-busy', 'true');
        if (button) { button.disabled = true; button.dataset.state = 'loading'; }
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(root + 'cart');
        } catch (error) {
          this.showError(error.message || this.dataset.error);
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          if (button) { button.disabled = false; button.dataset.state = 'idle'; }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
